import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
import AsyncDropdown from "components/library/AsyncDropdown";
import TextInput from "components/library/TextInput";
import Label from "components/library/Label";
import InputGroup from "editor/components/InputGroup";
import {
  validateDeepDiveFormAsync,
  onChangeField,
} from "deepDiveEditor/actions/form";
import { deepDiveInitialState } from "deepDiveEditor/reducers/form";
import { getDeepDiveSeriesListAsyncForTypeahead } from "deepDiveEditor/actions/metadata";
import {
  URL_PLACEHOLDER,
  COLOR_PLACEHOLDER,
  DEEP_DIVE_SERIES_PLACEHOLDER,
} from "config/constants/deepDiveEditor";

import styles from "./DeepDiveMetadata.css";

class DeepDiveMetadata extends React.Component {
  constructor(props) {
    super(props);
    this.idPrefix = "deep-dive-metadata";
  }

  getId(field) {
    return `${this.idPrefix}-${field}`;
  }

  render() {
    return (
      <div className={styles.root}>
        <InputGroup
          headerText="Ad Ops"
          inputs={[
            <>
              <Label htmlFor={this.getId("slug")}>Ad targeting ID*</Label>
              <TextInput
                id={this.getId("slug")}
                className={classNames(styles.input, "gtm-add-deep-dive-slug")}
                placeholder={URL_PLACEHOLDER}
                value={this.props.form.slug}
                error={this.props.form.errors.slug}
                onChange={this.props.onChangeField("slug")}
                onBlur={this.props.onChangeField("slug", true)}
              />
            </>,
            <>
              <Label htmlFor={this.getId("sponsored_text")}>
                Sponsored text
              </Label>
              <TextInput
                id={this.getId("slug")}
                className={classNames(styles.input, "gtm-add-sponsored-text")}
                placeholder={
                  'Add a sponsored text (e.g. "Presented by Facebook")'
                }
                value={this.props.form.sponsored_text}
                error={this.props.form.errors.sponsored_text}
                onChange={this.props.onChangeField("sponsored_text")}
                onBlur={this.props.onChangeField("sponsored_text", true)}
              />
            </>,
          ]}
        />
        <InputGroup
          headerText="Colors"
          className={styles.colorGroup}
          inputs={[
            <>
              <Label htmlFor={this.getId("bg_color")}>Background color</Label>
              {/* TODO: abstract out color field component */}
              <div className={styles.colorField}>
                <div
                  style={{
                    backgroundColor:
                      this.props.form.bg_color || deepDiveInitialState.bg_color,
                  }}
                  className={styles.colorPreview}
                ></div>
                <TextInput
                  id={this.getId("bg_color")}
                  className={classNames(styles.input, "gtm-add-bg-color")}
                  placeholder={COLOR_PLACEHOLDER}
                  value={this.props.form.bg_color}
                  error={this.props.form.errors.bg_color}
                  onChange={this.props.onChangeField("bg_color")}
                  onBlur={this.props.onChangeField("bg_color", true)}
                />
              </div>
            </>,
            <>
              <Label htmlFor={this.getId("text_color")}>Text color</Label>
              <div className={styles.colorField}>
                <div
                  style={{
                    backgroundColor:
                      this.props.form.text_color ||
                      deepDiveInitialState.text_color,
                  }}
                  className={styles.colorPreview}
                ></div>
                <TextInput
                  id={this.getId("text_color")}
                  className={classNames(styles.input, "gtm-add-text-color")}
                  placeholder={COLOR_PLACEHOLDER}
                  value={this.props.form.text_color}
                  error={this.props.form.errors.text_color}
                  onChange={this.props.onChangeField("text_color")}
                  onBlur={this.props.onChangeField("text_color", true)}
                />
              </div>
            </>,
            <>
              <Label htmlFor={this.getId("outline_color")}>Outline color</Label>
              <div className={styles.colorField}>
                <div
                  style={{
                    backgroundColor:
                      this.props.form.outline_color ||
                      deepDiveInitialState.outline_color,
                  }}
                  className={styles.colorPreview}
                ></div>
                <TextInput
                  id={this.getId("outline_color")}
                  className={classNames(styles.input, "gtm-add-outline-color")}
                  placeholder={COLOR_PLACEHOLDER}
                  value={this.props.form.outline_color}
                  error={this.props.form.errors.outline_color}
                  onChange={this.props.onChangeField("outline_color")}
                  onBlur={this.props.onChangeField("outline_color", true)}
                />
              </div>
            </>,
          ]}
        />
        <InputGroup
          headerText="Series"
          inputs={[
            <>
              <Label htmlFor={this.getId("series")}>Deep Dives series</Label>
              <AsyncDropdown
                className="gtm-add-series"
                inputId={this.getId("series")}
                value={this.props.form.series}
                onChange={this.props.onChangeField("series")}
                loadOptions={this.props.getDeepDiveSeriesListAsyncForTypeahead}
                labelKey="name"
                valueKey="slug"
                placeholder={DEEP_DIVE_SERIES_PLACEHOLDER}
              />
            </>,
          ]}
        />
      </div>
    );
  }
}

DeepDiveMetadata.propTypes = {
  validateDeepDiveFormAsync: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  onChangeField: PropTypes.func.isRequired,
  getDeepDiveSeriesListAsyncForTypeahead: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  form: state.deepDiveEditor.form,
});

const mapDispatchToProps = {
  validateDeepDiveFormAsync,
  onChangeField,
  getDeepDiveSeriesListAsyncForTypeahead,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeepDiveMetadata);
